// extracted by mini-css-extract-plugin
export default {"modalWindow":"InfoModal_modalWindow__fO9SA","modalBody":"InfoModal_modalBody__4uuH1","modalTitle":"InfoModal_modalTitle__r4T7E","modalSpotlight":"InfoModal_modalSpotlight__oDaes"};